import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
    const { status } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return (
            <div
                className="min-h-screen bg-[#0A0A0A] text-zinc-500 flex items-center justify-center font-manrope text-xs uppercase tracking-[0.3em]"
                data-testid="auth-loading"
            >
                Verifying…
            </div>
        );
    }

    if (status !== "authed") {
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }

    return children;
}
